import { useCallback, useEffect, useState } from "react";
import { getAuth, onAuthStateChanged } from "firebase/auth";

export const useAuthStatus = () => {
  const [loggedIn, setLoggedIn] = useState(false);
  const [checkingStatus, setCheckingStatus] = useState(true);
  const [emailVerified, setEmailVerified] = useState(false);
  const [userEmail, setUserEmail] = useState("");

  const syncUser = useCallback((user) => {
    setLoggedIn(!!user);
    setEmailVerified(!!user?.emailVerified);
    setUserEmail(user?.email || "");
  }, []);

  useEffect(() => {
    const auth = getAuth();
    const unsubscribe = onAuthStateChanged(auth, async (user) => {
      if (user) {
        try {
          await user.reload();
          syncUser(auth.currentUser);
        } catch {
          syncUser(user);
        }
      } else {
        syncUser(null);
      }
      setCheckingStatus(false);
    });
    return () => unsubscribe();
  }, [syncUser]);

  const refreshAuth = useCallback(async () => {
    const auth = getAuth();
    const user = auth.currentUser;
    if (!user) return false;

    await user.reload();
    syncUser(auth.currentUser);
    if (auth.currentUser?.emailVerified) {
      await auth.currentUser.getIdToken(true);
    }
    return !!auth.currentUser?.emailVerified;
  }, [syncUser]);

  return { loggedIn, checkingStatus, emailVerified, userEmail, refreshAuth };
};
